module.exports = __webpack_public_path__ + "static/media/empty-placeholder-bw.1d9f7199.jpg";